import { css } from '@emotion/react';
import { black } from 'styles/global_defaults/colors';
import t from 'react-translate';
import NvModal, { ModalType } from 'shared/components/nv-modal';
import prodPathReplace from 'shared/prod-path-rewrite';
import { headerLineHeight } from 'styles/global_defaults/fonts';

type PulseCheckConfirmationModalProps = {
  description: string;
  onClose: () => void;
};

const MODAL_WIDTH = 440;
const MODAL_HEIGHT = 350;

const styles = css`
  color: ${black};

  .description {
    line-height: ${headerLineHeight}px;
  }
`;

const PulseCheckConfirmationModal = ({
  description,
  onClose,
}: PulseCheckConfirmationModalProps) => {
  const src = prodPathReplace('images/all-done.svg');
  const title = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.SESSION_PULSE_CHECK.CONFIRMATION.TITLE();

  return (
    <NvModal
      show
      width={MODAL_WIDTH}
      height={MODAL_HEIGHT}
      type={ModalType.FIXED}
      headerBgColor='transparent'
      onClose={onClose}
      header=''
      body={(
        <div
          css={styles}
          className='d-flex flex-column align-items-center text-center'
        >
          <img src={src} alt={title} />
          <div className='w-100 pt-5'>
            <div className='heading-3 mb-2'>{title}</div>
            <div className='text-regular description'>{description}</div>
          </div>
        </div>
      )}
    />
  );
};

export default PulseCheckConfirmationModal;
